/**
 * Copy DÙNG CHUNG của bản tiếng Việt — thứ không thuộc riêng section nào: thương hiệu, nav,
 * meta trang, 404. (Copy footer đã chuyển sang `footer.ts` khi lô D dựng footer thật.)
 *
 * Copy của từng section nằm ở file riêng cạnh đây và đi theo lô dựng section đó (design doc
 * §12.3). Nhờ vậy lô sau THÊM một file, không sửa file của lô khác — điều kiện để các lô chạy
 * song song mà không giẫm lên nhau. Chỗ gộp tất cả lại là `./index.ts`.
 *
 * Mọi chuỗi dưới đây trích từ bản thiết kế `Nexa Landing (1).html` (thuộc tính `data-en` là bản
 * tiếng Anh của chính nó) — trừ `seo.home`, thiết kế không có meta nên phần đó viết mới.
 */
export const common = {
  brand: {
    name: 'Nexa',
    /** Dòng cạnh logo trong header — thiết kế dòng 585. */
    byline: 'by NewEra Inc.',
    tagline:
      'Hợp nhất chat, quản lý dự án, tri thức nội bộ và trợ lý AI trong cùng một không gian làm việc.',
  },

  /**
   * Nav của thiết kế là 6 ANCHOR trong trang (dòng 587–593), không phải link sang trang khác.
   * `id` khớp với `id` của section để `useScrollSpy` và `href="#…"` không thể lệch nhau.
   */
  nav: {
    items: [
      { id: 'modules', label: 'Tính năng' },
      { id: 'collab', label: 'Cộng tác' },
      { id: 'ai', label: 'AI Agents' },
      { id: 'security', label: 'Bảo mật' },
      { id: 'pricing', label: 'Bảng giá' },
      { id: 'faq', label: 'FAQ' },
    ],
    home: 'Trang chủ',
    cta: 'Dùng thử miễn phí',
    signIn: 'Đăng nhập',
    skipToContent: 'Bỏ qua, tới nội dung chính',
    openMenu: 'Mở menu',
    closeMenu: 'Đóng menu',
    languageSwitcher: 'Chọn ngôn ngữ',
    /** Nhãn cho `<nav>` chính — 6 anchor. Trang có 2 vùng điều hướng nên cả hai phải có tên. */
    mainNav: 'Điều hướng chính',
    /**
     * Nhãn HÀNH ĐỘNG của nút đổi ngôn ngữ. Nút hiện chữ 'VI' (mã ngôn ngữ ĐANG XEM, đúng thiết
     * kế) nhưng lại dẫn sang bản kia — không có nhãn này thì screen reader đọc ra "liên kết VI"
     * dẫn tới trang tiếng Anh.
     */
    switchTo: {
      vi: 'Chuyển sang tiếng Việt',
      en: 'Chuyển sang tiếng Anh',
    },
  },

  /**
   * Meta cho từng trang. Thiết kế không có thẻ meta nào, nên hai chuỗi dưới đây viết mới, dựa
   * trên h1 + lead của hero. Description giữ trong 120–160 ký tự.
   */
  seo: {
    home: {
      title: 'Nexa — một nơi làm việc, không còn phân mảnh',
      description:
        'Nexa hợp nhất chat theo channel & topic, quản lý dự án, tri thức nội bộ và trợ lý AI trong một workspace. Triển khai cloud hoặc on-premise.',
    },
  },

  page: {
    home: {
      heading: 'Một nơi làm việc. Không còn phân mảnh.',
      body: 'Nexa hợp nhất chat theo channel & topic, quản lý dự án, tri thức nội bộ và trợ lý AI trong cùng một không gian làm việc — triển khai trên cloud hoặc on-premise.',
    },
  },

  notFound: {
    title: 'Không tìm thấy trang',
    heading: '404 — Trang này không tồn tại',
    body: 'Liên kết có thể đã đổi hoặc bị gõ sai.',
    backHome: 'Về trang chủ',
  },
};
